import UnitInfoPlaceholder from './UnitInfoPlaceholder';
export default UnitInfoPlaceholder;
